/* eslint-disable */
const state = {
  hasFilledSurveyForm: "",
  endedTermId: "",
};

const getters = {
  getHasFilledSurveyForm: (state) => {
    return state.hasFilledSurveyForm;
  },
  getEndedTermId: (state) => {
    return state.endedTermId;
  },
};

const mutations = {
  setHasFilledSurveyForm: (state, payload) => {
    state.hasFilledSurveyForm = payload.value;
  },
  setEndedTermId: (state, payload) => {
    state.endedTermId = payload.value;
  },
};

const actions = {
  RESETSURVEYFORMSTATE: ({ commit }) => {
    commit("setHasFilledSurveyForm", { value: "" });
    commit("setEndedTermId", { value: "" });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
